import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Star, Quote } from 'lucide-react';

const reviews = [
  {
    id: 1,
    name: 'Elif Y.',
    rating: 5,
    text: 'Ankara\'da içtiğim en iyi kahve! Atmosfer harika, çalışanlar çok ilgili. Kesinlikle tavsiye ederim.',
    date: '2 hafta önce'
  },
  {
    id: 2,
    name: 'Ahmet K.',
    rating: 5,
    text: 'V60 kahveleri muhteşem. Çekirdeklerin tazeliği hemen hissediliyor. Yeni favori mekanım oldu.',
    date: '1 ay önce'
  },
  {
    id: 3,
    name: 'Zeynep D.',
    rating: 5,
    text: 'Hem çalışmak hem de arkadaşlarla buluşmak için mükemmel bir yer. Tatlıları da denemeye değer!',
    date: '3 hafta önce'
  },
  {
    id: 4,
    name: 'Mehmet A.',
    rating: 5,
    text: 'Specialty kahve konusunda Ankara\'nın en iyilerinden. Baristalar işini gerçekten iyi biliyor.',
    date: '1 hafta önce'
  },
  {
    id: 5,
    name: 'Selin Ö.',
    rating: 5,
    text: 'Cold brew muhteşem! Sıcak yaz günlerinde burası vazgeçilmezim. Mekan da çok şık.',
    date: '2 ay önce'
  },
  {
    id: 6,
    name: 'Can Y.',
    rating: 5,
    text: 'Her ziyaretimde aynı kalite. Tutarlılıkları takdire şayan. Croissant ve latte kombinasyonu harika!',
    date: '1 ay önce'
  }
];

const ReviewCard = ({ review, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="relative p-6 md:p-8 bg-[#2d4a3e] rounded-sm card-hover"
      data-testid={`review-card-${review.id}`}
    >
      {/* Quote icon */}
      <Quote className="absolute top-6 right-6 w-10 h-10 text-[#d4a84b]/20" />

      {/* Stars */}
      <div className="flex items-center gap-1 mb-4">
        {[...Array(review.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-[#d4a84b] text-[#d4a84b]" />
        ))}
      </div>

      {/* Review text */}
      <p className="text-[#b8c4b8] text-base leading-relaxed mb-6">
        "{review.text}"
      </p>

      {/* Author */}
      <div className="flex items-center justify-between">
        <div>
          <p className="text-[#f5f0e1] font-semibold">{review.name}</p>
        </div>
        <div className="flex items-center gap-1 px-3 py-1 bg-[#3d5a4e] rounded-full">
          <Star className="w-3 h-3 fill-[#d4a84b] text-[#d4a84b]" />
          <span className="text-[#f5f0e1] text-sm font-medium">5.0</span>
        </div>
      </div>
    </motion.div>
  );
};

const Reviews = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="reviews"
      ref={ref}
      className="py-24 md:py-32 bg-[#1a2e23] noise-overlay"
      data-testid="reviews-section"
    >
      <div className="container-custom">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 md:mb-24"
        >
          <span className="font-accent text-[#d4a84b] text-2xl" data-testid="reviews-label">
            Müşterilerimiz
          </span>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#f5f0e1] mt-4" data-testid="reviews-title">
            Yorumlar
          </h2>

          {/* Overall rating */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-8 h-8 fill-[#d4a84b] text-[#d4a84b]" />
              ))}
            </div>
            <div className="text-left">
              <p className="text-[#f5f0e1] text-3xl font-bold">5.0</p>
              <p className="text-[#b8c4b8] text-sm">15 değerlendirme</p>
            </div>
          </div>
        </motion.div>

        {/* Reviews grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="reviews-grid">
          {reviews.map((review, index) => (
            <ReviewCard key={review.id} review={review} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
